import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/config/constants";

const StickyMobileCTA: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-sm border-t border-border p-3 shadow-lg">
      <Button asChild size="lg" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground">
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2">
          <Calendar className="h-5 w-5" />
          Book a Chair Call
        </a>
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
